<template>
  <div class="header" :class="sidebarIsOpen ? 'sidebar-is-open' : ''">
    <v-card class="rounded-0 wrapper">
      <div class="left-side">
        <v-btn icon="mdi-menu" @click="toggleSideBar" variant="text"></v-btn>
      </div>
      <div class="middle-content">
        <img src="/images/easy-ticket-logo.svg"/>
      </div>
      <div class="right-side">
        <div class="user-section">
          <h3 class="name"> {{ loggedInUser.email }} </h3>
          <p class="type"> {{ getRoleString(loggedInUser.role) }} </p>
        </div>
        <dropdown class="dropdown" :menuItems="menuItems" :isHeader="true"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import Dropdown from '@/components/global/dropdown/Dropdown';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PagerHeader',
  components: {
    Dropdown,
  },
  data() {
    return {
      menuItems: [
        {
          title: this.$t('header.logout'),
          value: 1,
          icon: 'mdi-logout',
        },
      ]
    }
  },
  created() {
    this.emitter.on('clicked', (item) => {
      this.itemClicked(item);
    })
  },
  methods: {
    ...mapActions({
      logoutUser: 'users/logoutUser',
      toggleSideBarStore: 'siteSettings/toggleSidebar'
    }),
    getRoleString(value) {
      return value === 0 ? this.$t('enums.role.superAdmin') : this.$t('enums.role.admin');
    },
    itemClicked(item) {
      if (item.value == 0) {
        this.$router.push(item.path);
      }
      if (item.value == 1) {
        this.logoutUser();
        location.reload();
      }
    },
    toggleSideBar() {
      this.toggleSideBarStore();
    },
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'users/loggedInUser',
      sidebarIsOpen: 'siteSettings/sidebarIsOpen'
    }),
  }
};
</script>

<style lang="scss" scoped>
.header {
  z-index: 0;
  &.sidebar-is-open {
    @media (max-width: 620px) {
      z-index: 10;
    }
    .wrapper {
      padding-left: 240px;
      z-index: 10;
      @media (max-width: 620px) {
        padding-left: calc(100% - 60px);
        box-shadow: unset;
        background: 0;
        .right-side {
          display: none;
        }
      }
      .middle-content {
        display: none;
      }
      .left-side {
        width: 100%;
        z-index: 10;
        width: 60px;
      }
    }
  }
  .wrapper {
    transition: 0.4s all ease;
    height: 60px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    align-items: center;
    box-shadow: rgba(11, 81, 124, 0.2) 0px 3px 6px 0px;
    
    @media (max-width: 620px) {
      padding-left: 10px;

      .middle-content {
        display: none !important;
      }
    }

    .left-side {
      width: 200px;
    }

    .middle-content {
      width: 100%;
      display: flex;
      justify-content: space-around;
      img {
        width: 60px;
      }
    }

    .right-side {
      justify-content: flex-end;
      margin-left: auto;
      display: flex;
      align-items: center;
      width: 200px;
      .user-section {
        color: #434343;
        padding-right: 22px;
        white-space: nowrap;
        .name {
          font-size: 14px;
          font-weight: 550;
          text-align: right;
        }
        .type {
          font-size: 12px;
          text-align: right;
        }
      }
      .dropdown {
        @media (max-width: 1020px) {
          display: none;
        }
      }
    }
  }
}
</style>
